export const matchesMedia = (query: string): boolean =>
  Boolean(window.matchMedia?.(query)?.matches);

export const isPWA = (): boolean => matchesMedia('(display-mode: standalone)');

export const isCoarsePointer = (): boolean => matchesMedia('(pointer: coarse)');

export const prefersReducedMotion = (): boolean => matchesMedia('(prefers-reduced-motion: reduce)');
